import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DashboardsModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/dashboards.module';
import { DataSourceModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/data-source/data-source.module';
import { SmartGridModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/smart-grid/smart-grid.module';
import { environment } from '$env';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { ReportsComponentsModule } from './reports-components.module';
import { ReportsScreenComponent } from './screens/reports-screen/reports-screen.component';

@NgModule({
  imports: [
    CommonModule,
    DashboardsModule.forRoot({
      dataServiceApi: environment.cprServiceApi,
    }),
    DataSourceModule.forRoot({
      dataServiceApi: environment.cprServiceApi,
    }),
    SmartGridModule,
    ReportsComponentsModule,
    HeaderComponent,
  ],
  declarations: [ReportsScreenComponent],
})
export class ReportsModule {}
